<script setup lang="ts">
    import { useAppStore, usePageStore } from '#imports';

    /* Store variables */
    const { isMenu } = storeToRefs(useAppStore());
    const { pages } = storeToRefs(usePageStore());
</script>

<template>
    <v-navigation-drawer
        v-model="isMenu"
        style="background: rgb(var(--v-theme-surfaceEdgeLeft)); border-right: 1px solid rgb(var(--v-theme-surfaceEdgeRight)); top: 64px; height: calc(100% - 64px);"
        width="300"
        temporary>
        <v-banner
            class="text-center emboss color-tertiary justify-center text-h6"
            elevation="12"
            sticky
            style="background: rgb(var(--v-theme-surfaceEdgeBottom)); color: rgb(var(--v-theme-tertiary))">
            &nbsp;
        </v-banner>
        <v-list>
            <v-list-item v-for="(page) in pages.filter(p => p.isShow)"
                :to="page.to"
                :key="page.id"
                :value="page.id"
                color="primary"
                variant="text">
                {{ page.title }}
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>